import MicroModal from 'micromodal';

MicroModal.init();

const modalNav = document.querySelectorAll('[data-modal-nav]');

modalNav.forEach((el) => {
	el.addEventListener('click', (event) => {
		const currentId = el.closest('.l-modal').id;
		const modalId = el.dataset.modalNav;
		MicroModal.close(currentId);
		MicroModal.show(modalId);
		console.log(currentId);
		console.log(modalId);
		// event.target.classList.toggle('-active');
		// event.target.closest('.js-toggleWrapper').classList.toggle('-active');
	});
});
